import React from "react";

import FolhaCarregamento from "./FolhaCarregamento";
import FolhaSetor from "./FolhaSetor";

/** Escolhe o desenho pelo tipo da folha do domínio. */
export default function Folha(props) {
  return props.folha.tipo === "carregamento" ? <FolhaCarregamento {...props} /> : <FolhaSetor {...props} />;
}
